import type { Chatbot } from '@types'
import axios from 'axios'
import FormData from 'form-data'

import env from '../environments'

export async function createChatbot(
	brainId: string,
	chatbotName: string
) {
	const response = await axios.post(`${env.apiUrl}/chatbots/create`, {
		brainId,
		chatbotName
	})

	return response.data as Chatbot
}

export async function getChatbot(id: string) {
	const response = await axios.get(`${env.apiUrl}/chatbots/${id}`)

	return response.data as Chatbot
}

export async function previewChatbot(id: string) {
	const response = await axios.get(`${env.apiUrl}/chatbots/preview/${id}`)

	return response.data as string
}

export async function updateChatbot(chatbot: Partial<Omit<Chatbot, 'visibility'>> & {id: string}) {
	const response = await axios.put(`${env.apiUrl}/chatbots/${chatbot.id}`, chatbot)

	return response.data as Chatbot
}

export async function updateChatbotVisibility(chatbot: Partial<Chatbot> & {id: string; visibility: string}) {
	const response = await axios.put(`${env.apiUrl}/chatbots/${chatbot.id}`, chatbot)

	return response.data as Chatbot
}

export async function uploadChatbotImage(chatbotId: string, fileType: string, file: Blob) {
	const formData = new FormData()

	formData.append('file', file)
	formData.append('fileType', fileType)

	const response = await axios.post(`${env.apiUrl}/chatbots/${chatbotId}/upload`, formData, {
		headers: {
			// eslint-disable-next-line @typescript-eslint/naming-convention
			'Content-Type': 'multipart/form-data'
		}
	})

	return response.data as Chatbot
}

export async function deleteChatbot(chatbotId: string) {
	const response = await axios.delete(`${env.apiUrl}/chatbots/${chatbotId}`)

	return response.data as Chatbot
}

export async function deleteChatbotFile(chatbotId: string, fileType: 'chatIcon' | 'profilePicture') {
	const response = await axios.put(`${env.apiUrl}/chatbots/${chatbotId}/deleteFile`, { fileType })

	return response.data as Chatbot
}
